type FilledRectProps = {
    stages: number;
    fill: string;
    width: number;
    height: number;
    pad: number;
    gap: number;
};

export const FilledRects = ({stages, fill, width, height, pad, gap}: FilledRectProps) => {
    const maskWidth = width - 2 * pad;
    const stageWidth = (maskWidth - gap * (stages + 1)) / stages;
    const stageHeight = height - 2 * pad;

    const rects: null[] = new Array(stages).fill(null);

    return (
        <>
            {rects.map((_, index: number) => {
                return (
                    <rect
                        x={pad + gap + (stageWidth + gap) * index}
                        y={pad}
                        fill={fill}
                        width={stageWidth}
                        height={stageHeight}
                        rx={stageHeight / 2}
                    />
                );
            })}
        </>
    );
};
